import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';
import { useAnalytics } from '../utils/analytics/useAnalytics';

const Footer = () => {
  const location = useLocation();
  const { trackNavigation, trackExternal } = useAnalytics();

  const handleNavigation = (to) => {
    trackNavigation(location.pathname, to);
  };

  return (
    <footer className="footer">
      <div className="footer-shapes">
        <div className="footer-shape circle"></div>
        <div className="footer-shape square"></div>
        <div className="footer-shape triangle"></div>
      </div>

      <div className="footer-background"></div>
      <div className="footer-content">
        <div className="footer-section footer-logo">
          <div className="logoAnimation">
            <div className="imageContainer">
              <img
                src="/images/typoIcon1.png"
                alt="Dot Icon"
                className="image firstImage"
              />
              <img
                src="/images/typoIcon2.png"
                alt="Comma Icon"
                className="image secondImage"
              />
              <img
                src="/images/typoIcon3.png"
                alt="Smile Icon"
                className="image thirdImage"
              />
            </div>
          </div>
          <p className="company-name">TearFace</p>
          <p className="footer-copyright">&copy; 2025 TearFace. <br/> All rights reserved.</p>
        </div>
        <div className="footer-section quick-links">
          <h2>Quick Links</h2>
          <ul>
            <li><Link to="/" onClick={() => handleNavigation('/')}>Home</Link></li>
            <li><Link to="/accessibility" onClick={() => handleNavigation('/accessibility')}>Accessibility</Link></li>
            <li><Link to="/chat-support" onClick={() => handleNavigation('/chat-support')}>Chat Support</Link></li>
            <li><Link to="/portfolios" onClick={() => handleNavigation('/portfolios')}>Portfolios</Link></li>
            <li><Link to="/contact-us" onClick={() => handleNavigation('/contact-us')}>Contact Us</Link></li>
          </ul>
        </div>
        <div className="footer-section legal">
          <h2>Legal</h2>
          <ul>
            <li><Link to="/privacy-policy" onClick={() => handleNavigation('/privacy-policy')}>Privacy Policy</Link></li>
            <li><Link to="/terms-of-service" onClick={() => handleNavigation('/terms-of-service')}>Terms of Service</Link></li>
            <li><Link to="/cookie-policy" onClick={() => handleNavigation('/cookie-policy')}>Cookie Policy</Link></li>
            <li><Link to="/disclaimer" onClick={() => handleNavigation('/disclaimer')}>Disclaimer</Link></li>
          </ul>
        </div>
        <div className="footer-section resources">
          <h2>Resources</h2>
          <ul>
            <li><Link to="/accessibility#accessibility-plans-section" onClick={() => handleNavigation('/accessibility#accessibility-plans-section')}>Accessibility Pricing</Link></li>
            <li><Link to="/portfolios#faq-section" onClick={() => handleNavigation('/portfolios#faq-section')}>Portfolios FAQ's</Link></li>
            <li>
              <a 
                href="https://www.sourcetrooper.com" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => trackExternal('https://www.sourcetrooper.com')}
              >
                Automated Testing
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
